'use client';

import { useContext, useEffect, useState } from 'react';
import styles from './search.module.scss';
import { useRouter } from 'next/navigation';
import { Button, Input } from 'antd';
import { CiSearch } from 'react-icons/ci';
import { AppStorage } from '@/scripts';
import { GlobalContext } from '@/context';
import { BPEnum, LanguageEnum } from '@/types';
import { SliderWrapperComp } from '@/components';
import { __DummyData } from '../landing/landing.data';
import ServiceProviderCardComp from '../landing/serviceProviderCard/serviceProviderCard.index';
import { IoTrashOutline } from 'react-icons/io5';
import { PATH } from '@/data';
export default function Search() {
  const [searchText, setSearchText] = useState('');
  const [searchHistory, setSearchHistory] = useState<string[]>([]);
  const {
    langText,
    location
  } = useContext(GlobalContext);
  const language = langText.lang;
  const lang = langText.search;
  const router = useRouter();
  const handleClearHistory = () => {
    AppStorage.searchList.remove();
    setSearchHistory([]);
  };
  useEffect(() => {
    const history = AppStorage.searchList.get();
    setSearchHistory(history);
  }, []);
  const handleSearch = () => {
    if (searchText.trim()) {
      AppStorage.searchList.add(searchText.trim());
      setSearchHistory(AppStorage.searchList.get());
      router.push(PATH(language).services.index(location.slug, {
        search: searchText.trim()
      }));
    }
  };
  const specialServices = language === LanguageEnum.en ? __DummyData.specialServices.en : __DummyData.specialServices.fa;
  return <div className={`${styles['container']}`} data-sentry-component="Search" data-sentry-source-file="search.index.tsx">
            <div className={`${styles['search-box']}  mb-1 center-content`}>
                <Input value={searchText} onChange={e => setSearchText(e.target.value)} placeholder={lang.input_placeholder} suffix={<CiSearch onClick={handleSearch} />} onPressEnter={handleSearch} className="mh-auto" data-sentry-element="Input" data-sentry-source-file="search.index.tsx" />
            </div>
            <div className={styles['content']}>
                <div className={`${styles['search-history']} mh-auto`}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="t-p1 t-500-i t-dark2-i">{lang.history_title}</h6>
                        <Button type="text" className="t-p2-i t-400-i t-dark3-i d-flex-i align-items-center" onClick={handleClearHistory} data-sentry-element="Button" data-sentry-source-file="search.index.tsx">
                            <IoTrashOutline data-sentry-element="IoTrashOutline" data-sentry-source-file="search.index.tsx" />
                            {lang.delete_btn}
                        </Button>
                    </div>
                </div>
                <div className={`${styles['saved-words']} ${language === LanguageEnum.fa ? 'pr-6' : 'pl-6'} d-flex`}>
                    {searchHistory.map((word, index) => {
          return <Button key={index} type="text" onClick={() => {
            setSearchText(() => word);
            router.push(PATH(language).services.index(location.slug, {
              search: word
            }));
          }} className="t-dark3-i pv-1-i">
                                {word}
                            </Button>;
        })}
                    <div className={styles['gradient-overlay']}></div>
                </div>
            </div>
            <SliderWrapperComp items={[...specialServices, ...specialServices, ...specialServices]} child={ServiceProviderCardComp} innerClassName={() => styles['card']} noLoop rows={1} origin={0.05} loadingHeight={356} hideArrow layout={[{
      max_width: BPEnum.SM,
      perView: 1.3,
      spacing: 12
    }, {
      max_width: BPEnum.MD,
      perView: 1.8,
      spacing: 12
    }, {
      max_width: BPEnum.LG,
      perView: 2.3
    }, {
      max_width: BPEnum.XL,
      perView: 2.45
    }, {
      max_width: BPEnum.XXL,
      perView: 2.6,
      origin: 0.075
    }]} data-sentry-element="SliderWrapperComp" data-sentry-source-file="search.index.tsx" />
        </div>;
}